import React, { createContext, useState } from 'react';
import styled from 'styled-components';

import {
  Flexbox,
  iBinderMainTheme,
  Layout as CFLayout
} from '@ibinder/common-frontend';
import { BINDER_NAME } from '../placeholderData';
import RightTabsMenu from './RightTabsMenu';

const OuterWrapper = styled.div`
  margin: 1rem;
  min-height: calc(100vh - 4.5rem);
  display: flex;
  justify-content: center;
  @media (max-width: ${(props) => props.theme.devices.md}px) {
    margin: 0;
  }
`;

const ContentWrapper = styled(Flexbox)`
  width: 100%;
  position: relative;
  @media (max-width: ${(props) => props.theme.devices.md}px) {
    padding: 0 0.5rem;
  }
`;

const StyledLayout = styled(CFLayout)`
  width: 100%;
`;

export const AdminBinderContext = createContext(null);

const AdminLayout = ({ activeTabId, location, children }) => {
  const binderSpread = window.location.pathname === `/`;
  const [rightPanelOpen, setRightPanelOpen] = useState(true);

  const toggleTabsMenu = () => {
    setRightPanelOpen(!rightPanelOpen);
  };

  return (
    <AdminBinderContext.Provider
      value={{
        binderSpread,
        toggleTabsMenu,
        rightPanelOpen,
        setRightPanelOpen,
        activeTabId
      }}
    >
      <OuterWrapper>
        <StyledLayout maxWidth={iBinderMainTheme.devices.xxl}>
          <ContentWrapper
            isBinderSpread={binderSpread}
            isToggled={toggleTabsMenu}
          >
            {children}
            <RightTabsMenu
              rightPanelOpen={rightPanelOpen}
              toggleTabsMenu={toggleTabsMenu}
              binderSpread={binderSpread}
              BINDER_NAME={BINDER_NAME}
            />
          </ContentWrapper>
        </StyledLayout>
      </OuterWrapper>
    </AdminBinderContext.Provider>
  );
};

export default AdminLayout;
